var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeamticket = function SvgTeamticket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.667 11.333H7.333a2.667 2.667 0 0 1-2.666-2.666v-4A2.667 2.667 0 0 1 7.333 2h4A2.667 2.667 0 0 1 14 4.667V8a3.333 3.333 0 0 1-3.334 3.333",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 11.333h.963c.573 0 1.037-.464 1.037-1.037v-.889c0-1.145.929-2.074 2.074-2.074h.889A1.037 1.037 0 0 0 14 6.296v-.963"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.333 11.267v.066A2.667 2.667 0 0 1 8.667 14h-4A2.667 2.667 0 0 1 2 11.333v-4a2.667 2.667 0 0 1 2.667-2.666v0"
  })));
};
export { SvgTeamticket as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOWM3NDZlNzA1MzgzYWVkODA4MTljNzMxOWU4NGVlNTcuc3ZnIjs=";